import { Component, Input, OnInit } from '@angular/core';
import { IROPS_STATUS, TYPE_IROPS } from '@app/enums/irops.enum';

@Component({
    selector: 'subtitle-irops-rebrand',
    templateUrl: './subtitle-irops-rebrand.component.html',
    styleUrls: ['./subtitle-irops-rebrand.component.scss'],
    standalone: false
})
export class SubtitleIropsRebrandComponent implements OnInit {
  typeIrops = IROPS_STATUS;

  @Input() subtitle = this.typeIrops.DELAYED;

  constructor() { }

  ngOnInit() {
  }

}
